import React, { type ReactElement } from "react"

import { Container } from "./_styles"

const Divisor = (): ReactElement => {
  return <Container />
}

export default Divisor
